import {StyleSheet} from 'react-native';
import {scaleFonts} from '@buncha/appStyles/style/font';

export const styles = StyleSheet.create({
  listContainer: {
    paddingVertical: 20,
  },
  listContentContainer: {
    paddingBottom: 150,
  },
  itemContainer: {
    marginRight: 20,
  },
  itemRow: {
    justifyContent: 'flex-start',
  },
  itemImage: {
    width: scaleFonts(74),
    height: scaleFonts(74),
    marginRight: 15,
  },
  subItemImage: {
    width: scaleFonts(50),
    height: scaleFonts(39),
    marginRight: 5,
  },
  backupTag: {
    position: 'absolute',
    top: 0,
    left: -20,
    backgroundColor: 'white',
    borderWidth: 1,
    paddingHorizontal: 10,
    paddingVertical: 2,
    borderBottomRightRadius: 5,
    borderTopRightRadius: 5,
    zIndex: 999,
  },
  itemDetailsContainer: {
    flex: 1,
    gap: 5,
  },
  itemTitle: {
    textAlign: 'left',
  },
  itemUnavailableTag: {
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 5,
  },
  replacementContainer: {
    marginTop: 10,
    padding: 5,
    borderRadius: 5,
    justifyContent: 'flex-start',
    gap: 10,
  },
  replacementImage: {
    width: scaleFonts(34),
    height: scaleFonts(34),
    borderRadius: 5,
  },
  replacementTextBox: {
    gap: 2,
    flex: 1,
  },
  replacementLabel: {
    textAlign: 'left',
  },
  replacementTitle: {
    textAlign: 'left',
    marginRight: 20,
  },
  separatorWrapper: {
    // marginHorizontal: 10,
  },
  separator: {
    marginVertical: 20,
    height: 2,
  },
  currencyText: {textAlign: 'left'},
  tab: {
    marginTop: 30,
    borderWidth: 2,
  },
  tabContainer: {marginTop: 10, height: '100%', marginHorizontal: 10},
  noItemsImage: {
    height: 152,
    width: 100,
  },
  noItemsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80%',
  },
  subsContainer: {
    alignItems: 'flex-start',
    borderWidth: 1,
    borderRadius: 5,
    borderLeftWidth: 4,
    padding: 10,
    marginRight: -20,
  },
  customerSubContainer: {maxWidth: '100%'},
  subNameContainer: {
    alignItems: 'flex-start',
    maxWidth: '100%',
    flex: 1,
  },
  dropReasonText: {
    textAlign: 'left',
  },
});
